enum CacheMode {
  Default = 'default',
  ForceCache = 'force-cache',
  NoCache = 'no-store'
}

export default CacheMode
